import { BaseModel } from '../../shared/models/base.model';
import { PaymentTermStrategy } from './payment-term-strategy.model';
import { PaymentPlanPreview } from './payment-plan-preview.model';

export class PaymentTerm  extends BaseModel {
  id: number;
  uuid: string;
  name: string;
  description: string;
  payment_term_strategy: PaymentTermStrategy;
  previewData?: PaymentPlanPreview;
  default: boolean;

  constructor(params: any) {
    super(params);
  }
}
